export default "public/1SFA616903R1019.svg";